"use client";

import { useState } from "react";
import { formatPrice } from "@/lib/mock-data";

const VAT = 1.21;

export default function PriceBox({
  price,
  months,
  kmPerYear,
}: {
  price: number;
  months: number;
  kmPerYear: number;
}) {
  const [withVat, setWithVat] = useState(false);
  const displayed = withVat ? Math.round(price * VAT) : price;

  return (
    <div className="bg-[#1a6ef5] rounded-2xl p-5 mb-4 text-white">
      <div className="flex items-center justify-between mb-2">
        <p className="text-blue-100 text-sm">Měsíční splátka od</p>
        <button
          onClick={() => setWithVat((v) => !v)}
          className="flex items-center gap-1 text-xs bg-white/20 hover:bg-white/30 rounded-full px-2.5 py-1 transition-colors"
        >
          <span className={withVat ? "text-blue-200" : "font-semibold"}>bez DPH</span>
          <span className="text-blue-300 mx-0.5">·</span>
          <span className={withVat ? "font-semibold" : "text-blue-200"}>s DPH</span>
        </button>
      </div>
      <div className="flex items-baseline gap-1">
        <span className="text-4xl font-extrabold">{formatPrice(displayed)}</span>
        <span className="text-lg font-semibold">Kč</span>
        <span className="text-blue-200 text-sm">/měs.</span>
      </div>
      <p className="text-blue-200 text-xs mt-1">
        {withVat ? "vč. DPH (21 %)" : "bez DPH"} · {months} měsíců · {formatPrice(kmPerYear)} km/rok
      </p>
    </div>
  );
}
